<h1 matDialogTitle>

  <ng-container *ngIf="!data.billingSetup.id && data.isRegistrationRequest">Setup</ng-container>
  <ng-container *ngIf="data.billingSetup.id">Edit Setup</ng-container>
</h1>
<mat-dialog-content>

  <aw-edit-form-setup [billingSetup]="data.billingSetup" [isRegistrationRequest]="data.isRegistrationRequest"
    (saved)="dialogRef.close(true)" (canceled)="dialogRef.close(false)"></aw-edit-form-setup>

</mat-dialog-content>